<template>
  <div class="w100 pl20 pr20 pt20 pb20 bigbox">
    <div class="title">
      岗位聘用查询
    </div>
    <div  class="seachCla">
    <el-row>
      <el-col class="flex-box al-c" :span="5">
        <span class="mr10 tx-r">岗位类别</span>
        <el-select
          v-model="searchData.postTypeId"
          placeholder="请选择岗位类别"
          @change="change"
        >
          <el-option
            v-for="item in parentList"
            :key="item.postInfoId"
            :label="item.postInfo"
            :value="item.postInfoId"
          >
          </el-option>
        </el-select>
      </el-col>

      <el-col class="flex-box al-c" :span="5">
        <span class="mr10 tx-r">岗位等级</span>
        <el-select
          v-model="searchData.postGradeId"
          placeholder="请选择岗位等级"
          @change="changeValue"
        >
          <el-option
            v-for="item in childList"
            :key="item.postInfoId"
            :label="item.postInfo"
            :value="item.postInfoId"
          >
          </el-option>
        </el-select>
      </el-col>

      <el-col class="flex-box al-c" :span="5">
        <span class="mr10 tx-r" style="width: 40px">姓名</span>
        <el-input
          v-model.trim="searchData.userName"
          placeholder="请输入姓名"
        ></el-input>
      </el-col>

      <el-col class="flex-box al-c" :span="7">
        <el-button class="mb10 ml10" type="primary" @click="initPage"
          >查询</el-button
        >
        <el-button class="mb10 ml10" type="primary" @click="reset"
          >重置</el-button
        >
        <el-button class="mb10 ml10" type="primary" @click="downloadTemplate"
          >模板下载</el-button
        >
        <el-button class="mb10 ml10" type="primary" @click="importExcel"
          >导入</el-button
        >
      </el-col>
    </el-row>
</div>
    <div class="table-con">
      <el-table
        class="table"
        header-row-class-name="table-head"
        row-class-name="cu-p"
        stripe
        :data="tableData"
        v-loading="loading"
      >
        <el-table-column align="center" label="序号" width="50px">
          <template slot-scope="scope">{{
            current * size - size + scope.$index + 1
          }}</template>
        </el-table-column>
        <el-table-column
          prop="userName"
          label="姓名"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="workCode"
          label="工号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="contractCode"
          label="合同编号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="postTypeInfo"
          label="岗位类别"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="postGradeInfo"
          label="岗位等级"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="employStartTime"
          label="聘岗时间"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
    </div>
    <div class="mt20 flex-box pagegation">
      <div class="flex-1"></div>
      <el-pagination
        background
        @current-change="changePage"
        :current-page="current"
        :page-size="size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <importExcel
      ref="uplodModal"
      :uplodData="uplodData"
      @closeUplod="closeUplod"
      @successCallBack="saveSuccess"
      url="/hallportal/hq/postEmploy/export"
    ></importExcel>
  </div>
</template>

<script>
import {
  postEmploy,
  jobDowlod,
  parentList,
  childList,
} from "@/api/management/staff";
import importExcel from "@/components/dialog/import/importExcel.vue";
export default {
  name: "search",
  components: {
    importExcel,
  },
  props: [],
  data() {
    return {
      parentList: [],
      childList: [],
      searchData: {
        postTypeId: "",
        postGradeId: "",
        userName: "",
      },

      loading: false,
      current: 1,
      size: 10,
      total: 0,
      tableData: [],
      uplodData: {
        state: false,
        type: "",
      },
    };
  },
  computed: {},
  created() {
    this.getParentList();
    this.$nextTick(() => {
      this.initPage();
    });
  },
  mounted() {},
  destroyed() {},
  methods: {
    initPage() {
      this.current = 1;
      this.getList();
    },

    change(value) {
      this.getChildList(value);
      this.searchData.postGradeId = "";
      // this.initPage();
    },
    changeValue() {
      // this.initPage();
    },
    // 获取岗位类别
    async getParentList() {
      const { data } = await parentList();
      if (data.code == 0) {
        this.parentList = data.data;
        if(this.parentList.length>0){
          // this.searchData.postTypeId = this.parentList[0].postInfoId
          this.getChildList(this.searchData.postTypeId)
        }
      }else{
        this.$message.error(data.msg)
      }
    },
    // 获取岗位等级
    async getChildList(id) {
      const { data } = await childList(id);
      if (data.code == 0) {
        this.childList = data.data;
      }
    },
    changePage(page) {
      this.current = page;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const params = {
        ...this.searchData,
        current: this.current,
        size: this.size,
      };
      const { data } = await postEmploy(params);
      this.loading = false;
      if (data.code == 0) {
        this.tableData = data.data.records;
        this.total = data.data.total;
      } else {
        this.$message.error(data.msg);
      }
    },
    reset() {
      // if(this.parentList.length>0){
      //    this.searchData.postTypeId = this.parentList[0].postInfoId
      //    this.getChildList(this.searchData.postTypeId)
      // }
      this.searchData = {
        postTypeId:"",
        postGradeId:"",
        userName:''
      }
      this.getChildList(this.searchData.postTypeId)
      this.initPage();
    },
    closeUplod(val) {
      this.uplodData.state = val;
    },
    saveSuccess() {
      this.initPage();
    },
    importExcel() {
      this.uplodData.state = true;
    },
    // 模板下载
    downloadTemplate() {
      this.downloadFn(jobDowlod());
    },
    downloadFn(url) {
      this.$DownLoad(
        url,
        null,
        (res) => {
          if (res.status != 200) {
            this.$alert("下载出错,请稍后重试", "提示", {
              confirmButtonText: "确定",
              type: "warning",
            });
          }
        },
        (error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
            type: "warning",
          });
        }
      );
    },
  },
};
</script>

<style scoped lang="less">
.bigbox{
  height: 100%;
  display: flex;
  flex-direction: column;
  .pagegation{
    width: 100%;
  }
}
.table-con{
  background-color: white;
  margin-top: 10px;
  width: 100%;
  flex: 1;
}
.seachCla{
  padding: 20px 20px 10px 20px;
    // background-color: #ffffff;
    width: 100%;
}
/deep/.el-table {
  width: 100%;
  .el-table__body-wrapper {
    max-height: calc(100vh - 300px);
    overflow-y: auto;
  }
}
.title{
  padding: 0px 0px 10px 0px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
</style>
